import React from "react";
import "./_Price.scss";
export const Price = ({ price }) => {
  return <div className="price">S./{price}</div>;
};
